module.exports = __webpack_public_path__ + "img/find-more-expenses-2.138527cb.svg";